import type { AxiosError } from 'axios'

export type HttpRequest = {
  payload?: unknown
  showInfo?: boolean
  showSuccess?: boolean
}

export type HttpResponseError = AxiosError<{
  message: string
  statusCode: number
  error: string
}>

export type HttpResponse = {
  body: string
  status: number
  message: string
}

export type AxiosHttpClient = {
  sendRequest: (request: HttpRequest) => Promise<HttpResponse>
}

export enum HttpStatusCode {
  OK = 200,
  NO_CONTENT = 202,
  UNAUTHORIZED = 401,
  SERVER_ERROR = 500,
}
